export default __webpack_public_path__ + "static/media/Version (6) - Ultimate Map_15.ecc2c1a2.jpg";